/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsightfulnessCriterion } from './InsightfulnessCriterion';
import {
  InsightfulnessCriterionFromJSON,
  InsightfulnessCriterionFromJSONTyped,
  InsightfulnessCriterionToJSON,
} from './InsightfulnessCriterion';
import type { PerformanceMetric } from './PerformanceMetric';
import {
  PerformanceMetricFromJSON,
  PerformanceMetricFromJSONTyped,
  PerformanceMetricToJSON,
} from './PerformanceMetric';
import type { QuestionnaireAssessment } from './QuestionnaireAssessment';
import {
  QuestionnaireAssessmentFromJSON,
  QuestionnaireAssessmentFromJSONTyped,
  QuestionnaireAssessmentToJSON,
} from './QuestionnaireAssessment';
import type { AiModel } from './AiModel';
import { AiModelFromJSON, AiModelFromJSONTyped, AiModelToJSON } from './AiModel';
import type { ModelTypeEnum } from './ModelTypeEnum';
import { ModelTypeEnumFromJSON, ModelTypeEnumFromJSONTyped, ModelTypeEnumToJSON } from './ModelTypeEnum';
import type { DatasetPipelineList } from './DatasetPipelineList';
import {
  DatasetPipelineListFromJSON,
  DatasetPipelineListFromJSONTyped,
  DatasetPipelineListToJSON,
} from './DatasetPipelineList';
import type { StyleCriterion } from './StyleCriterion';
import { StyleCriterionFromJSON, StyleCriterionFromJSONTyped, StyleCriterionToJSON } from './StyleCriterion';
import type { ProtectedGroupDataset } from './ProtectedGroupDataset';
import {
  ProtectedGroupDatasetFromJSON,
  ProtectedGroupDatasetFromJSONTyped,
  ProtectedGroupDatasetToJSON,
} from './ProtectedGroupDataset';
import type { RiskMetric } from './RiskMetric';
import { RiskMetricFromJSON, RiskMetricFromJSONTyped, RiskMetricToJSON } from './RiskMetric';
import type { PersonalDataExposureCategory } from './PersonalDataExposureCategory';
import {
  PersonalDataExposureCategoryFromJSON,
  PersonalDataExposureCategoryFromJSONTyped,
  PersonalDataExposureCategoryToJSON,
} from './PersonalDataExposureCategory';
import type { ReportType } from './ReportType';
import { ReportTypeFromJSON, ReportTypeFromJSONTyped, ReportTypeToJSON } from './ReportType';

/**
 *
 * @export
 * @interface QuestionnaireAnswer
 */
export interface QuestionnaireAnswer {
  /**
   *
   * @type {number}
   * @memberof QuestionnaireAnswer
   */
  readonly id: number;
  /**
   *
   * @type {AiModel}
   * @memberof QuestionnaireAnswer
   */
  readonly aiModel: AiModel;
  /**
   *
   * @type {DatasetPipelineList}
   * @memberof QuestionnaireAnswer
   */
  readonly datasetPipeline: DatasetPipelineList;
  /**
   *
   * @type {Array<RiskMetric>}
   * @memberof QuestionnaireAnswer
   */
  readonly selectedRiskMetrics: Array<RiskMetric>;
  /**
   *
   * @type {Array<StyleCriterion>}
   * @memberof QuestionnaireAnswer
   */
  readonly styleCriteria: Array<StyleCriterion>;
  /**
   *
   * @type {ModelTypeEnum}
   * @memberof QuestionnaireAnswer
   */
  modelType?: ModelTypeEnum | null;
  /**
   *
   * @type {ProtectedGroupDataset}
   * @memberof QuestionnaireAnswer
   */
  readonly protectedGroupDataset: ProtectedGroupDataset;
  /**
   *
   * @type {Array<PerformanceMetric>}
   * @memberof QuestionnaireAnswer
   */
  readonly performanceMetrics: Array<PerformanceMetric>;
  /**
   *
   * @type {ReportType}
   * @memberof QuestionnaireAnswer
   */
  readonly reportType: ReportType;
  /**
   *
   * @type {Array<InsightfulnessCriterion>}
   * @memberof QuestionnaireAnswer
   */
  readonly insightfulnessCriteria: Array<InsightfulnessCriterion>;
  /**
   *
   * @type {Array<PersonalDataExposureCategory>}
   * @memberof QuestionnaireAnswer
   */
  readonly personalDataExposureCategories: Array<PersonalDataExposureCategory>;
  /**
   *
   * @type {string}
   * @memberof QuestionnaireAnswer
   */
  user?: string;
  /**
   *
   * @type {Date}
   * @memberof QuestionnaireAnswer
   */
  timestamp?: Date;
  /**
   *
   * @type {Array<QuestionnaireAssessment>}
   * @memberof QuestionnaireAnswer
   */
  readonly assessments: Array<QuestionnaireAssessment>;
}

/**
 * Check if a given object implements the QuestionnaireAnswer interface.
 */
export function instanceOfQuestionnaireAnswer(value: object): value is QuestionnaireAnswer {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('aiModel' in value) || value['aiModel'] === undefined) return false;
  if (!('datasetPipeline' in value) || value['datasetPipeline'] === undefined) return false;
  if (!('selectedRiskMetrics' in value) || value['selectedRiskMetrics'] === undefined) return false;
  if (!('styleCriteria' in value) || value['styleCriteria'] === undefined) return false;
  if (!('protectedGroupDataset' in value) || value['protectedGroupDataset'] === undefined) return false;
  if (!('performanceMetrics' in value) || value['performanceMetrics'] === undefined) return false;
  if (!('reportType' in value) || value['reportType'] === undefined) return false;
  if (!('insightfulnessCriteria' in value) || value['insightfulnessCriteria'] === undefined) return false;
  if (!('personalDataExposureCategories' in value) || value['personalDataExposureCategories'] === undefined)
    return false;
  if (!('assessments' in value) || value['assessments'] === undefined) return false;
  return true;
}

export function QuestionnaireAnswerFromJSON(json: any): QuestionnaireAnswer {
  return QuestionnaireAnswerFromJSONTyped(json, false);
}

export function QuestionnaireAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireAnswer {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    aiModel: AiModelFromJSON(json['ai_model']),
    datasetPipeline: DatasetPipelineListFromJSON(json['dataset_pipeline']),
    selectedRiskMetrics: (json['selected_risk_metrics'] as Array<any>).map(RiskMetricFromJSON),
    styleCriteria: (json['style_criteria'] as Array<any>).map(StyleCriterionFromJSON),
    modelType: json['model_type'] == null ? undefined : ModelTypeEnumFromJSON(json['model_type']),
    protectedGroupDataset: ProtectedGroupDatasetFromJSON(json['protected_group_dataset']),
    performanceMetrics: (json['performance_metrics'] as Array<any>).map(PerformanceMetricFromJSON),
    reportType: ReportTypeFromJSON(json['report_type']),
    insightfulnessCriteria: (json['insightfulness_criteria'] as Array<any>).map(InsightfulnessCriterionFromJSON),
    personalDataExposureCategories: (json['personal_data_exposure_categories'] as Array<any>).map(
      PersonalDataExposureCategoryFromJSON,
    ),
    user: json['user'] == null ? undefined : json['user'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assessments: (json['assessments'] as Array<any>).map(QuestionnaireAssessmentFromJSON),
  };
}

export function QuestionnaireAnswerToJSON(
  value?: Omit<
    QuestionnaireAnswer,
    | 'id'
    | 'aiModel'
    | 'datasetPipeline'
    | 'selectedRiskMetrics'
    | 'styleCriteria'
    | 'protectedGroupDataset'
    | 'performanceMetrics'
    | 'reportType'
    | 'insightfulnessCriteria'
    | 'personalDataExposureCategories'
    | 'assessments'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    model_type: ModelTypeEnumToJSON(value['modelType']),
    user: value['user'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
  };
}
